import { render } from "./RequestFormComponent.vue?vue&type=template&id=04f1ea84&scoped=true"
import script from "./RequestFormComponent.vue?vue&type=script&lang=js"
export * from "./RequestFormComponent.vue?vue&type=script&lang=js"

import "./RequestFormComponent.vue?vue&type=style&index=0&id=04f1ea84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f1ea84"]])

export default __exports__